import type { PhotoAsset } from "./types";

export const photos: readonly PhotoAsset[] = [
  {
    slug: "site-hero",
    ref: { kind: "public", key: "public/artwork/site/hero/hero-wide-1600.jpg" },
    alt: "7 Minutes Dead — Diamond Cat aesthetic, wide hero",
    orientation: "landscape",
    // Brand visual — not a real press photo. About-page Photos block shows
    // its "hunting down photos" skeleton until something tagged "press"
    // actually lands.
    tags: ["promo"],
    width: 1600,
    height: 900,
  },
];
